import { withInstall } from '@jdesign-vue/utils'
import Progress from './src/progress.vue'

export const JdProgress = withInstall(Progress)
export default JdProgress

export * from './src/progress'
